import { render, staticRenderFns } from "./IconDynamic.vue?vue&type=template&id=30b5c1b4&"
import script from "./IconDynamic.vue?vue&type=script&lang=js&"
export * from "./IconDynamic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports